/**
 * Estem kayıt dönemi bilgisi:
 * - Her ayın 8'ine kadar evrak toplama son gün
 * - Her ayın 10'unda yeni dönem başlar
 * - Bu yüzden ayın 8'i "kayıt son günü"
 */
const MONTHS_TR = [
  "Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran",
  "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"
];

export function getDeadlineInfo(now = new Date()) {
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  let deadline;
  // If today is day 1-8, deadline is 8th of THIS month
  if (today.getDate() <= 8) {
    deadline = new Date(today.getFullYear(), today.getMonth(), 8);
  } else {
    // Otherwise deadline is 8th of NEXT month
    deadline = new Date(today.getFullYear(), today.getMonth() + 1, 8);
  }
  const diffMs = deadline - today;
  const days = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
  const monthName = MONTHS_TR[deadline.getMonth()];

  let urgency, badge, headline, subline;
  if (days <= 0) {
    // deadline day itself
    urgency = "critical";
    badge = "SON GÜN!";
    headline = "Bugün kayıt olmazsanız 1 ay bekleyeceksiniz!";
    subline = `Bugün kayıt son günü. Yarın (${MONTHS_TR[deadline.getMonth()]} ${deadline.getDate() + 2}) sonraki dönem başlıyor. Şimdi başvurmazsanız 1 ay kaybedersiniz.`;
  } else if (days <= 2) {
    urgency = "critical";
    badge = `SON ${days} GÜN!`;
    headline = `Bir sonraki döneme yetişmek için ${days} gününüz kaldı`;
    subline = `${monthName} 10'da yeni dönem başlıyor. Kayıtları ${monthName} 8'de kapatıyoruz. Şimdi kayıt olun, 1 ay kaybetmeyin.`;
  } else if (days <= 7) {
    urgency = "warning";
    badge = `Kayıtlara ${days} gün kaldı`;
    headline = `${monthName} dönemine yetişmek için son ${days} gün`;
    subline = `Kayıtları ${monthName} 8'de kapatıyoruz. Şimdi başvurun, ${monthName} 10'da derslere başlayın.`;
  } else if (days <= 15) {
    urgency = "attention";
    badge = `${monthName} Dönemi Yaklaşıyor`;
    headline = `Sonraki dönem ${days} gün sonra başlıyor`;
    subline = `Kayıtları ${monthName} 8'de kapatıyoruz. Bir sonraki dönem için hemen kayıt olun.`;
  } else {
    urgency = "normal";
    badge = `${monthName} Dönemi Kayıtları Açık`;
    headline = "Yeni dönem kayıtları başladı";
    subline = `Kayıtları ${monthName} 8'de kapatıyoruz. Erken kaydolun, en iyi eğitmenden ders alın.`;
  }
  return { days, deadline, monthName, urgency, badge, headline, subline };
}
